import { useEffect } from 'react';
import HeaderMetedBase from './HeaderMetedBase';

//import { FormattedMessage} from 'react-intl';
import { useDispatch, useSelector } from 'react-redux'
import { getCatalog } from '../../actions'
import FetchError from '../FetchError.react';
import AppSchemaErrors from '../AppSchemaErrors';
import Loading from './Loading';
import LegacyMetedContainer from './LegacyMetedContainer';
import Footer from './Footer';


function TranscriptsPage(props) {
    const dispatch = useDispatch();
    const search = useSelector((state) => state.search);
    const viewer = useSelector((state) => state.viewer);

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return <BrowseContainer  />

   

}

const BrowseContainer = () => {

    return (
        <div id='et-browse-container'>

            <HeaderMetedBase activePage="catalog" />
            <LegacyMetedContainer />
            <Footer />
        </div>
    );
};

export default TranscriptsPage;